<div class="fixed transform z-2" *ngIf="showProgressSpinner">
  <app-custom-spinner></app-custom-spinner>
</div>

<div class="bg-default px-3 pb-3">
  <div class="flex justify-content-between align-items-center title-bg title-case">
    <div class="conten">
      <div class="btn"><a>Counter Measures</a></div>
    </div>
    <div class="flex justify-content-end">
      <span class="p-input-icon-left">
        <i class="pi pi-search"></i>
        <input pInputText type="text" (input)="applyFilterGlobal($event, 'contains')" placeholder="Search..." />
      </span>
    </div>
  </div>
</div>
  <div class="col-12 md:col-12 lg:col-12">
    <p-table #dt [value]="counterMeasuresData" [rows]="rows"
      styleClass="p-datatable-striped p-datatable-gridlines createRoles" [paginator]="true" sortMode="multiple"
      [lazy]="true" responsiveLayout="scroll" [rowHover]="true" dataKey="casenumber" [totalRecords]="totalRecords"
      (onLazyLoad)="lazyLoadSchedules($event)" [columns]="cols" [resizableColumns]="false" columnResizeMode="expand"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[10,15,25,50,totalRecords]" [globalFilterFields]="['PatientName']">
      <ng-template pTemplate="header">
        <tr>
          <th style="width:5rem" pResizableColumn></th>
          <th style="width:15rem" pSortableColumn="CaseNumber" pResizableColumn>
            TeleCare Case # 
            <p-sortIcon field="CaseNumber"></p-sortIcon>
          </th>
          <th style="width:30rem" pSortableColumn="FacilityName" pResizableColumn>
            Facility
            <p-sortIcon field="FacilityName"></p-sortIcon>
          </th>
          <th style="width:20rem" pSortableColumn="PatientName" pResizableColumn>
            Patient Name
            <p-sortIcon field="PatientName"></p-sortIcon>
          </th>
          <th style="width:20rem" pSortableColumn="DateofService" pResizableColumn>
            Date of Service
            <p-sortIcon field="DateofService"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-counterMeasuresData let-expanded="expanded">
        <tr>
          <td>
            <button type="button" [pTooltip]="expanded ? 'Close Countermeasure' : 'Open Countermeasure'" pButton pRipple [pRowToggler]="counterMeasuresData" class="p-button-text p-button-rounded p-button-plain" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
        </td>
        <td>
          <ng-container *ngIf="RoleName.toLowerCase().includes('facility')">{{counterMeasuresData.casenumber}}</ng-container>
          <ng-container *ngIf="!RoleName.toLowerCase().includes('facility')">
            <a [href]="accessCase + counterMeasuresData.casekey + showPopupOnLoad" target="_blank">{{counterMeasuresData.casenumber}}</a>
          </ng-container>
        </td>
          <td [pSelectableRow]="counterMeasuresData">{{counterMeasuresData.facility}}</td>
          <td [pSelectableRow]="counterMeasuresData">{{counterMeasuresData.PatientName}}</td>
          <td [pSelectableRow]="counterMeasuresData">{{counterMeasuresData.DateOfService}}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="rowexpansion" let-counterMeasuresData>
        <tr>
            <td colspan="7">
                <div class="p-p-3" style="width: 94% !important; margin-left: 6% !important;">
                    <p-table [value]="counterMeasuresData._objCounterMeasures" [resizableColumns]="false" dataKey="rca_root_cause">
                        <ng-template pTemplate="header">
                            <tr>
                              <th style="width:20rem" >Root Cause</th>
                              <th style="width:20rem" >Countermeasure(S)</th>
                              <th style="width:20rem" >Responsible Party</th>
                              <th style="width:20rem" >Proposed Due Date</th>
                              <th style="width:20rem;" >Completed Date</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-counterMeasure>
                            <tr>
                              <td [ngStyle]="counterMeasure.status == true && counterMeasure.rca_completed_date == null ? {'color':'white','background-color':'#ed2078'} : {'color':'black'}">{{counterMeasure.rca_root_cause}}</td>
                              <td [ngStyle]="counterMeasure.status == true && counterMeasure.rca_completed_date == null ? {'color':'white','background-color':'#ed2078'} : {'color':'black'}">{{counterMeasure.rca_proposed_countermeasure}}</td>
                              <td [ngStyle]="counterMeasure.status == true && counterMeasure.rca_completed_date == null ? {'color':'white','background-color':'#ed2078'} : {'color':'black'}">{{counterMeasure.rca_responsible_party}}</td>
                              <td [ngStyle]="counterMeasure.status == true && counterMeasure.rca_completed_date == null ? {'color':'white','background-color':'#ed2078'} : {'color':'black'}">{{counterMeasure.rca_proposed_due_date}}</td>
                              <td [ngStyle]="counterMeasure.status == true && counterMeasure.rca_completed_date == null ? {'color':'white','background-color':'#ed2078'} : {'color':'black'}">{{counterMeasure.rca_completed_date | date:'dd/MM/yyyy'}}</td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="6">There are no data for this countermeasure yet.</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </td>
        </tr>
    </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <h5 *ngIf="totalRecords==0" class="text-center create-roles">
            <b> No records found</b>
          </h5>
        </tr>
      </ng-template>
    </p-table>
    <div class="md:col-12">
      <span class="tableRefreshTime">
        Grid Last Refreshed at {{analyzeService._currentDate}} - {{analyzeService._currentTime}}
      </span>
    </div>
  </div>

<p-dialog header="Countermeasure - Case # {{case_number}}" [draggable]="false" 
  [(visible)]="displayCounterMeasures" [style]="{width: '75vw', height: '15vw'}" [modal]="true">
  <p-table [value]="SpecificCounterMeasure" responsiveLayout="scroll">
    <ng-template pTemplate="header">
      <tr>
        <th style="width:70rem;" class="radius-left">Root Cause</th>
        <th style="width:40rem">Countermeasure(S)</th>
        <th style="width:40rem">Responsible Party</th>
        <th style="width:30rem">Proposed Due Date</th>
        <th style="width:30rem;" class="radius-right">Completed Date</th>
      </tr>
      
    </ng-template>
    <ng-template pTemplate="body" let-SpecificCounterMeasure>
      <tr>
        <td>{{SpecificCounterMeasure.rca_root_cause}}</td>
        <td>{{SpecificCounterMeasure.rca_proposed_countermeasure}}</td>
        <td *ngIf="SpecificCounterMeasure.rca_responsible_party != 'null'">
          {{SpecificCounterMeasure.rca_responsible_party != null || SpecificCounterMeasure.rca_responsible_party != "null" || SpecificCounterMeasure.rca_responsible_party != undefined ? SpecificCounterMeasure.rca_responsible_party : 'trjry'}}
        </td>
        <td>{{SpecificCounterMeasure.rca_proposed_due_date}}</td>
        <td>{{SpecificCounterMeasure.rca_completed_date}}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <h5 *ngIf="SpecificCounterMeasure.length == 0" class="text-center create-roles">
          <b> No records found</b>
        </h5>
      </tr>
    </ng-template>
  </p-table>
</p-dialog>
